<template>
  <el-form-item
    :label="label"
    class="password"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="password"
      type="text"
      :clearable="true"
      :maxlength="20"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      show-password
      prefix-icon="el-icon-lock"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: 'パスワード'
    },
    prop: {
      type: String,
      default: 'password'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: '最大20文字'
    }
  },
  computed: {
    password: {
      get () {
        return this.value
      },
      set (password) {
        this.$emit('input', password)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
